import { render, staticRenderFns } from "./archives.vue?vue&type=template&id=e4c76e44&scoped=true&"
import script from "./archives.vue?vue&type=script&lang=js&"
export * from "./archives.vue?vue&type=script&lang=js&"
import style0 from "./archives.vue?vue&type=style&index=0&id=e4c76e44&lang=scss&scoped=true&"
import style1 from "./archives.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c76e44",
  null
  
)

export default component.exports